<template>
<div>
  <!-- PASO 1 -->
  <modal :show.sync="showModalFirstStep" size="lg">
    <h6 slot="header" class="modal-title">Crear plan - Paso 1</h6>

    <div class="form-row">
        <div class="col-md-12">
              <base-input label="Categoría">
                  <el-select clearable @change="fetchSubcategoriasList" v-model="model.categoria" filterable
                              placeholder="Seleccione categoría">
                      <el-option v-for="option in selectCategorias"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row" v-if="model.categoria != '' && model.categoria">
        <div class="col-md-12">
              <base-input label="Subcategoría">
                  <el-select clearable v-model="model.subcategoria" filterable
                              placeholder="Seleccione subcategoría">
                      <el-option v-for="option in selectSubcategorias"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row">
        <div class="col-md-12">
              <base-input label="Compañía">
                  <el-select  v-model="model.company" filterable
                              placeholder="Seleccione compañia">
                      <el-option v-for="option in selectCompanies"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row">
        <div class="col-md-12">
              <base-input label="Sponsor">
                  <el-select  v-model="model.sponsor" filterable
                              placeholder="Seleccione sponsor">
                      <el-option v-for="option in selectSponsors"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-input label="Nombre"
                    placeholder="Ingrese un nombre"
                    name="nombre"
                    v-model="model.name">
        </base-input>
      </div>
    </div>
    <template slot="footer">
      <base-button :disabled="model.sponsor == '' || !model.sponsor || model.categoria == '' || !model.categoria || model.subcategoria == '' || !model.subcategoria || model.company == '' || !model.company || model.name == '' || !model.name " type="primary" @click="toSecondStep" >Siguiente</base-button>
      <base-button type="link" class="ml-auto" @click="showModalFirstStep = false">Cancelar</base-button>
    </template>

  </modal>
  <!-- PASO 2 -->
  <modal :show.sync="showModalSecondStep" size="lg">
    <h6 slot="header" class="modal-title">Crear plan - Paso 2</h6>
    <h1 class="display-4">Filtros de búsqueda</h1>
    
    <div class="form-row" v-for="(item,i) in campos_enum" :key="i">
        <div class="col-md-12">
          <base-input :label="'Elija qué opción ['+(item.nombre_publico || item.nombre_identificatorio)+'] corresponde:'">
              <el-select  v-model="model.campos_enum[i]" filterable
                          placeholder="Seleccione opción...">
                  <el-option v-for="option in item.opciones"
                              :key="option"
                              :label="option"
                              :value="option">
                  </el-option>
              </el-select>
          </base-input>
        </div>
    </div>
    
    <div class="form-row" v-for="(itm,iql) in campos_range" :key="iql+'A'">
        <div class="col-md-6" >
          <base-input v-model="model.campos_range[iql].desde" :label="'Filtrar ['+(itm.nombre_publico || itm.nombre_identificatorio)+'] desde:'" type="number" step="0.001" />
        </div>
        <div class="col-md-6" >
          <base-input v-model="model.campos_range[iql].hasta" :label="'Filtrar ['+(itm.nombre_publico || itm.nombre_identificatorio)+'] hasta:'" type="number" step="0.001" />
        </div>
    </div>
    
    <h1 class="display-4">Pricing</h1>
    <p class="lead" style="font-size: 0.8rem;" >
      En este apartado puedes definir la fórmula de pricing que tendrá el plan, o en su defecto el valor fijo en la moneda asociada al plan. Puedes utilizar las siguientes variables en la fórmula por su respectiva letra.
    </p>
    <h4  v-if="campos_formulas.length > 0">Variables:</h4>
    
    <div class="row" v-if="campos_formulas.length > 0">
        <div class="table-responsive">
            <base-table class="table  mt-1"
                        :data="campos_formulas">
                <template slot="columns">
                    <th class="text-center px-0 bg-transparent" scope="col">Variable</th>
                    <th class="text-center bg-transparent" scope="col">Letra </th>
                </template>
                
                <template slot-scope="{row,index}">
                    <td class="text-center px-0">{{row.nombre_publico || row.nombre_identificatorio}}</td>
                    <td class="text-center">{{letras[index]}}</td>
                </template>
                
            </base-table>
        </div>
    </div>
    
    <h4>Fórmula pricing:</h4>
    <div class="form-row">
      <div class="col-md-12">
        <base-input v-model="formula" label="Escriba la fórmula:"  placeholder="ej: (3*x + 12000)/0.75*y" />
        <small>Nota: Para multiplicación debe utilizar explicitamente el operador *</small>
      </div>
    </div>
    <badge v-if="formulaComputed" rounded type="success">Formula Correcta</badge>
    <badge v-if="!formulaComputed" rounded type="danger">Formula Incorrecta</badge>
    <div class="form-row mt-4">
        <div class="col-md-12">
              <base-input label="Moneda en la que se valoriza el plan"
                          name="moneda"
                          :error="getError('moneda')"
                          v-validate="'required'"
                          v-model="model.moneda"
              >
                  <el-select clearable v-model="model.moneda" filterable
                              placeholder="Seleccione moneda"
                              ref="selectMoneda"
                              >
                      <el-option v-for="option in selectMonedas"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row" v-if="model.moneda != 'CLP'" >
        <div class="col-md-6">
          <base-input label="Tipo de conversión">
              <el-select clearable v-model="model.tipo_conversion" filterable
                          placeholder="Seleccione tipo de conversión">
                  <el-option v-for="option in selectTiposConversion"
                              :key="option.label"
                              :label="option.label"
                              :value="option.value">
                  </el-option>
              </el-select>
          </base-input>
        </div>
        <div class="col-md-6" v-if="model.tipo_conversion == 'xday'">
          <base-input addon-left-icon="ni ni-calendar-grid-58" label="Ingrese fecha específica:">
            <flat-picker slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="model.valor_conversion">
            </flat-picker>
          </base-input>
        </div>
        <div class="col-md-6" v-if="model.tipo_conversion == 'daysbefore'">
          <base-input v-model="model.valor_conversion" type="number" label="Indique cantidad de días" min="0" />
        </div>
        <div class="col-md-6" v-if="model.tipo_conversion == 'weeksbefore'">
          <base-input v-model="model.valor_conversion" type="number" label="Indique cantidad de semanas" min="0" />
        </div>
        <div class="col-md-6" v-if="model.tipo_conversion == 'monthsbefore'">
          <base-input v-model="model.valor_conversion" type="number" label="Indique cantidad de meses" min="0" />
        </div>
        <div class="col-md-6" v-if="model.tipo_conversion == 'fixedvalue'">
          <base-input  v-model="model.valor_conversion" step="0.01" type="number" :label="'Indique el valor fijo de la moneda: '+$refs.selectMoneda.selectedLabel" min="0" />
        </div>
    </div>
    <template slot="footer">
      <base-button :disabled="!secondStepReady" type="primary" @click="toThirdStep" >Siguiente</base-button>
      <base-button type="link" class="ml-auto" @click="showModalSecondStep = false">Cancelar</base-button>
    </template>
  </modal>
  <!--
    PASO 3
  -->
  <modal :show.sync="showModalThirdStep" size="lg">
    <h6 slot="header" class="modal-title">Crear plan - Paso 3</h6>
    <div class="form-row">
        <div class="col-md-12">
              <base-input label="Materia asegurada"
                          name="materia asegurada"
                          :error="getError('materia asegurada')"
                          v-validate="'required'"
                          v-model="model.materia"
              >
                  <el-select clearable v-model="model.materia" filterable
                              placeholder="Seleccione la materia a asegurar en este plan">
                      <el-option v-for="option in selectMaterias"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-input label="Consideraciones:">
          <wysiwyg v-model="model.consideraciones" />
        </base-input>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-input label="Condiciones generales y específicas:">
          <wysiwyg v-model="model.condiciones" />
        </base-input>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-checkbox class="mb-3" v-model="model.payment_required">
          ¿ Requiere pago ?
        </base-checkbox>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-checkbox class="mb-3" v-model="model.sign_required">
          ¿ Requiere firma ?
        </base-checkbox>
      </div>
    </div>
    <!--
    <div class="form-row">
      <div class="col-md-6">
        <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de vigencia desde:"
                    name="fecha de vigencia desde"
                    :error="getError('fecha de vigencia desde')"
                    v-validate="'required'"
                    v-model="model.vigencia_desde"
        >
          <flat-picker slot-scope="{focus, blur}"
                      @on-open="focus"
                      @on-close="blur"
                      :config="config"
                      class="form-control datepicker"
                      v-model="model.vigencia_desde">
          </flat-picker>
        </base-input>
      </div>
      <div class="col-md-6">
        <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de vigencia hasta:"
                    name="fecha de vigencia hasta"
                    :error="getError('fecha de vigencia hasta')"
                    v-validate="'required'"
                    v-model="model.vigencia_hasta"
        >
          <flat-picker slot-scope="{focus, blur}"
                      @on-open="focus"
                      @on-close="blur"
                      :config="config"
                      class="form-control datepicker"
                      v-model="model.vigencia_hasta">
          </flat-picker>
        </base-input>
      </div>
    </div>
    -->
    <div class="form-row">
      <div class="col-md-6">
        <base-input 
          type="number"
          step="1"
          min="1"
          label="Duración de Vigencia"
          v-model="model.duracion"
          name="Duración de Vigencia"
          :error="getError('Duración de Vigencia')"
          v-validate="'required'"
        >

        </base-input>
      </div>
      <div class="col-md-6">
        <base-input label="Unidad de tiempo"
          v-model="model.unidad_duracion"
          name="Unidad de tiempo"
          :error="getError('Unidad de tiempo')"
          v-validate="'required'"
        >
            <el-select  clearable v-model="model.unidad_duracion" filterable
                        placeholder="Unidad de tiempo">
              <el-option v-for="option in selectUnidades"
                          :key="option.label"
                          :label="option.label"
                          :value="option.value">
              </el-option>
            </el-select>
        </base-input>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-6">
        <base-input 
          type="number" 
          v-model="model.limite_siniestros" 
          min="0" label="Límite de siniestros (0 = Ilimitados)" 
          name="Limite de siniestros"
          :error="getError('Limite de siniestros')"
          v-validate="'required|min:0'"  
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-input 
          label="Porcentaje de monto cubierto (**)"
          type="number"
          step="0.01"
          min="0"
          max="100"
          placeholder="Porcentaje cubierto"
          v-model="model.cubierto"
        >
          <small slot="append" class="font-weight-bold">%</small>
        </base-input>
        <small>** Dejar en 0 si no aplica a este Plan</small>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12">
        <base-input 
          label="Documento descargable"
          type="text"
          placeholder="Link a documento descargable"
          v-model="model.file_url"
        >
        </base-input>
      </div>
    </div>
    <template slot="footer">
      <base-button :disabled="thirdStepReady" type="primary" @click="sendForm" >Crear Plan</base-button>
      <base-button type="link" class="ml-auto" @click="showModalThirdStep = false">Cancelar</base-button>
    </template>
  </modal>
</div>
</template>
<script>
import { Select, Option } from 'element-ui';
import BaseTable from '@/components/BaseTable';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import HtmlEditor from '@/components/Inputs/HtmlEditor';
const FormulaParser = require('hot-formula-parser').Parser;
var parser;

  export default {
    components: {
        BaseTable,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        HtmlEditor
    },
    data() {
      return {
        validated: false,
        model: {
          categoria: '',
          subcategoria: '',
          company: '',
          sponsor: '',
          name: '',
          sign_required: false,
          vigencia_desde: '',
          vigencia_hasta: '',
          campos_enum: [],
          campos_variable: [],
          campos_range: [],
          payment_required: false,
          materia: undefined,
          moneda: undefined,
          tipo_conversion: undefined,
          valor_conversion: undefined,
          consideraciones: '',
          condiciones: '',
          limite_siniestros: 0,
          duracion: 1,
          unidad_duracion: 'dias',
          cubierto: 0.0,
          file_url: '',
        },
        showModalFirstStep: false,
        showModalSecondStep: false,
        showModalThirdStep: false,
        selectCategorias: [], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectSubcategorias: [],
        selectCompanies: [],
        selectSponsors: [],
        searattrsData: [],
        letras: ['x', 'y', 'z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w' ],
        formula: '',
        campos_formulas: [],
        campos_enum: [],
        campos_variable: [],
        campos_range: [],
        config: { dateFormat: 'd-m-Y', allowInput: true },
        selectMaterias: [],
        selectMonedas: [],
        selectTiposConversion: [
            {label: 'Default (Fecha actual)' , value: 'current' },
            {label: 'Dia específico', value: 'xday' },
            {label: 'Último cierre mensual', value: 'endlastmonth' },
            {label: 'X dias atrás', value: 'daysbefore' },
            {label: 'X semanas atrás', value: 'weeksbefore' },
            {label: 'X meses atrás', value: 'monthsbefore' },
            {label: 'Valor Fijo', value: 'fixedvalue' }
          ],
        selectUnidades: [
          { label: 'Días', value: 'dias' },
          { label: 'Meses', value: 'meses' },
          { label: 'Años', value: 'años' }
        ],
        parser: undefined
      }
    },
    methods: {
      
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      fetchCategoriasList(){
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_categories_from_create_plan'
        }).then(response => {
            vm.selectCategorias = response.data;

        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchSubcategoriasList(){
        this.model.subcategoria = undefined;
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_subcategories_from_create_plan?categoria='+this.model.categoria
        }).then(response => {
            //if( response.data.length == 0 ) vm.model.subcategoria = undefined;
            
            vm.selectSubcategorias = response.data;
            console.log(vm.selectSubcategorias);
        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchCompaniesList(){
        this.model.company = undefined;
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_companies_from_create_plan'
        }).then(response => {
            vm.selectCompanies = response.data;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchSponsorsList(){
        this.model.sponsor = undefined;
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_sponsors_from_create_plan'
        }).then(response => {
            vm.selectSponsors = response.data;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchSearchablesdAttributesData()
      {
        var vm = this;
        this.axios({
          url: 'api/get_searattrs_from_create_plan',
          method: 'POST',
          data: {
            subcategory: vm.model.subcategoria
          }
        }).then(response => {
          vm.parser = new FormulaParser(); 
          vm.searattrsData = response.data;
          
          vm.campos_formulas =  vm.searattrsData.filter( elem => 
            elem.tipo_campo == 'VARIABLE' || (elem.tipo_campo == 'RANGE' && (elem.tipo_dato == 'float' || elem.tipo_dato == 'int'))
          );
          vm.campos_enum = vm.searattrsData.filter( elem => 
            elem.tipo_campo == 'ENUM'
          );
          vm.model.campos_enum = [];
          vm.campos_enum.forEach(elem => {
            vm.model.campos_enum.push(undefined);
          });
          vm.campos_range = vm.searattrsData.filter( elem => 
            elem.tipo_campo == 'RANGE'
          );
          vm.model.campos_range = [];
          vm.campos_range.forEach( elem => {
            vm.model.campos_range.push({desde: undefined, hasta: undefined});
          });
          vm.campos_variable = vm.searattrsData.filter( elem =>
            elem.tipo_campo == 'VARIABLE'
          );
          vm.model.campos_variable = [];
          vm.campos_formulas.forEach( (elem, i) => {
            vm.model.campos_variable.push({id: elem.id, letra: vm.letras[i]});
            vm.parser.setVariable(vm.letras[i], 1);
            console.log('vm.parser.setVariable',vm.letras[i], 1);
          });
          
        }).catch( error => {

        })
        ;
      },
      fetchMateriasList()
      {
        var vm = this;
        this.axios({
          url: 'api/get_materias_list_from_create_plan',
          method: 'GET'
        }).then( response => {
          vm.selectMaterias = response.data;
        }).catch( error => {
          console.log(error);
        });
        ;
      },
      fetchMonedasList()
      {
        var vm = this;
        this.axios({
          url: 'api/get_currencies_list_from_create_plan',
          method: 'GET'
        }).then( response => {
          vm.selectMonedas = response.data;
        }).catch( error => {
          console.log(error);
        })
        ;
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);

          if( response ){
            vm.axios({
                method: 'POST',
                url: 'api/store_create_plan',
                data: {   
                        categoria: this.model.categoria,
                        subcategoria: this.model.subcategoria,
                        company: this.model.company,
                        sponsor: this.model.sponsor,
                        nombre: this.model.name,
                        sign_required: this.model.sign_required,
                        //vigencia_desde: this.$moment(this.model.vigencia_desde, "DD-MM-YYYY").format('YYYY-MM-DD'),
                        //vigencia_hasta: this.$moment(this.model.vigencia_hasta, "DD-MM-YYYY").format('YYYY-MM-DD'),
                        campos_enum: this.model.campos_enum,
                        formula: this.formula,
                        campos_range: this.model.campos_range,
                        payment_required: this.model.payment_required,
                        materia: this.model.materia,
                        moneda: this.model.moneda,
                        tipo_conversion: ((this.model.tipo_conversion == '' || this.model.tipo_conversion == undefined) ? 'current': this.model.tipo_conversion),
                        valor_conversion: this.model.valor_conversion,
                        consideraciones: this.model.consideraciones,
                        condiciones: this.model.condiciones,
                        campos_variable: this.model.campos_variable,
                        limite_siniestros: this.model.limite_siniestros,
                        duracion: this.model.duracion,
                        unidad_duracion: this.model.unidad_duracion,
                        cubierto: this.model.cubierto,
                        file_url: this.model.file_url
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Plan creado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModalThirdStep = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar el plan',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
      },
      toSecondStep()
      {
        this.showModalFirstStep = false;
        this.showModalSecondStep = true;
        //this.showModalThirdStep = true;
        this.fetchSearchablesdAttributesData();
        this.fetchMonedasList();
      },
      toThirdStep()
      {
        
        this.showModalSecondStep = false;
        this.showModalThirdStep = true;
        this.fetchMateriasList();
        
      }
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('showModalCreatePlan', () => { 
        this.showModalFirstStep = true; 
        this.fetchCategoriasList(); 
        this.fetchCompaniesList(); 
        this.fetchSponsorsList();
        
        } );
      this.parser = new FormulaParser(); 
    },
    computed: {
      formulaComputed(){
        return this.parser.parse(this.formula).result? true: false;
      },
      secondStepReady(){
        var flag = true;
        this.model.campos_enum.forEach( elem => {
          if( elem == '' || elem == undefined) flag = false;
        });
        this.model.campos_range.forEach( elem => {
          console.log('debio haber entrado aqui');
          console.log(parseInt(elem.desde),parseInt(elem.hasta), parseInt(elem.hasta) < parseInt(elem.desde));
          if( elem.desde == '' || 
              elem.desde == undefined || 
              !elem.desde ||
              parseInt(elem.desde) < 0 || 
              elem.hasta == '' || 
              elem.hasta == undefined || 
              parseInt(elem.hasta) < parseInt(elem.desde) ||
              !elem.hasta ||
              parseInt(elem.hasta) < 0 ){
            flag = false;
          }
          
        });
        if( !this.formulaComputed ) flag = false;
        if( !this.model.moneda || !this.model.tipo_conversion ) flag = false;
        if( !this.model.duracion || !this.model.unidad_duracion ) flag = false;
        console.log('resultado secondStepReady', flag);
        return flag;
      },
      thirdStepReady(){
        return false;
      }
    }
  }
</script>
<style>
</style>
